<template>
  <div
    class="col-span-5 pt-7 px-3 flex justify-center items-center border-solid border-0 border-l-2"
    :class="`border-${message.borderColor}`"
  >
    <span class="h-px border-0 border-t border-solid border-soft flex-1"/>

    <router-link
      :to="eventDetailLink"
      class="flex gap-1 items-center justify-center text-center border border-gray border-solid bg-white p-3 cursor-pointer rounded hover:border-focus"
      :class="{ 'border-focus bubble-shadow': isSelected }"
      @click.native="selectBubble"
    >
      <EventsIcon class="w-4 h-4 text-gray"/>
      <span class="text-sm text-gray">Event:</span>
      <span class="text-sm text-gray-dark">{{ eventName }}</span>
      <vx-tooltip v-if="showDuplicateBadge"
                  :text="duplicateTooltip"
                  position="top"
                  class="inline-flex items-center justify-center py-0.5 px-2 ml-1 text-xs font-semibold text-white bg-body rounded-full min-w-[2rem]"
      >
        {{ duplicateCount }}x
      </vx-tooltip>
    </router-link>

    <span class="h-px border-0 border-t border-solid border-soft flex-1"/>
  </div>
</template>

<script>
import ChatGPTActionPlaceholder from '@/components/common/ChatGPTActionPlaceholder'
import EventsIcon from '@/assets/images/icons/EventsIcon'

export default {
  name: 'ConversationEvent',

  components: { ChatGPTActionPlaceholder, EventsIcon },

  props: {
    message: {
      type: Object,
      required: true
    },
    selectedBubble: {
      type: Object,
      default: null
    }
  },

  emits: ['bubble-selected'],

  computed: {
    isSelected() {
      return this.selectedBubble && this.selectedBubble.messageId === this.message.id
    },

    eventName() {
      return this.message?.data?.event?.name
    },

    duplicateCount() {
      return this.message.duplicateCount || 1
    },

    showDuplicateBadge() {
      return this.duplicateCount > 1
    },

    eventDetailLink() {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, messageId: this.message.id, requestId: undefined }
      }
    },

    duplicateTooltip() {
      return `<b>Consecutive identical events merged</b><br/>The same event occurred ${this.duplicateCount} times in a row and was combined to improve readability.`
    }
  },

  methods: {
    selectBubble() {
      this.$emit('bubble-selected')
    }
  }
}
</script>

<style lang="scss" scoped>
.bubble-shadow {
  box-shadow: 0 4px 11px 0 theme('colors.focus-a50');
}
</style>
